// Reads a CSS variable from :root at runtime so Chart.js can consume it.
// Falls back to a safe default if the var is not set (e.g., during SSR tests).
export const getCssVar = (varName, fallback = '31 147 255') => {
  if (typeof window === 'undefined') return fallback;
  return (
    getComputedStyle(document.documentElement).getPropertyValue(varName).trim() ||
    fallback
  );
};

export const brandColor = (alpha = 1) =>
  `rgb(${getCssVar('--brand-primary-rgb')} / ${alpha})`;

export const brandAccentColor = (alpha = 1) =>
  `rgb(${getCssVar('--brand-secondary-rgb')} / ${alpha})`;

export const wootColor = (tone = 500, alpha = 1) =>
  `rgb(${getCssVar(`--woot-${tone}`)} / ${alpha})`;
